import BaseService from "../BaseService";
import http from "../HttpService";
import { API_BASE_URL_ENV } from "helpers/common";

const apiEndpoint = API_BASE_URL_ENV() + "/site/contact-us";

export default class ContactUsService {
    contactUs = (data)=>{
        return http.post(apiEndpoint, data)
    }
 
}
